var map = {
	"./biodiversity_and_ecosystems.svg": 2952,
	"./circular_economy.svg": 2953,
	"./climate_change_adaptation.svg": 2954,
	"./climate_change_mitigation.svg": 2955,
	"./pollution_prevention.svg": 2956,
	"./water_and_marine_resources.svg": 2957
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1836;